// Kanonische Plattform-Domain (Session A, Legal-Routen).
//
// Beim Domain-Umzug scrolly.online → scrolly.com ist NUR diese Konstante
// zu ändern — alle Legal-Links in Footer/Sidebar hängen hieran.
//
// Bewusst NICHT verwendet von den älteren Hardcodes in usePublicAuth,
// OidcAuthProvider und allowed-return-domains (Auth-Flow-Refactor ist
// nicht Session-A-Scope; siehe Briefing Scope-Ergänzung b).
export const PLATFORM_BASE_URL = "https://platform.scrolly.online";

export const LEGAL_URLS = {
  imprint: `${PLATFORM_BASE_URL}/imprint`,
  privacy: `${PLATFORM_BASE_URL}/privacy`,
  terms: `${PLATFORM_BASE_URL}/terms`,
} as const;
